import { render, staticRenderFns } from "./ProSale.vue?vue&type=template&id=7e66928a&scoped=true"
import script from "./ProSale.vue?vue&type=script&lang=js"
export * from "./ProSale.vue?vue&type=script&lang=js"
import style0 from "./ProSale.vue?vue&type=style&index=0&id=7e66928a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66928a",
  null
  
)

export default component.exports